/**
 * AusMed mobile mega drawer: Level 1 list ↔ Level 2 slide-in panels (inside header-drawer).
 */
function getViewport(drawer) {
  return drawer.querySelector('[data-ausmed-mobile-drawer-viewport]');
}

function getDetails(drawer) {
  return drawer.querySelector('details.menu-drawer-container');
}

function showLevel1(viewport) {
  if (!viewport) return;
  viewport.dataset.activeLevel = '1';
  const l1 = viewport.querySelector('[data-ausmed-drawer-pane="1"]');
  const l2s = viewport.querySelectorAll('[data-ausmed-drawer-pane="2"]');
  l1?.removeAttribute('hidden');
  l2s.forEach((p) => {
    p.hidden = true;
    p.classList.remove('is-active');
  });
  viewport.querySelectorAll('[data-ausmed-open-panel]').forEach((btn) => {
    btn.setAttribute('aria-expanded', 'false');
  });
}

function showPanel(viewport, panelId) {
  if (!viewport || !panelId) return;
  const panel = document.getElementById(`ausmed-mobile-panel-${panelId}`);
  if (!panel) return;
  const l1 = viewport.querySelector('[data-ausmed-drawer-pane="1"]');
  viewport.dataset.activeLevel = '2';
  l1?.setAttribute('hidden', '');
  viewport.querySelectorAll('[data-ausmed-drawer-pane="2"]').forEach((p) => {
    p.hidden = true;
    p.classList.remove('is-active');
  });
  panel.hidden = false;
  panel.classList.add('is-active');
  const opener = viewport.querySelector(`[data-ausmed-open-panel="${panelId}"]`);
  opener?.setAttribute('aria-expanded', 'true');
  const focusTarget = panel.querySelector('[data-ausmed-drawer-back]') || panel;
  focusTarget.focus?.();
}

function initAusmedMobileDrawer(drawer) {
  const viewport = getViewport(drawer);
  if (!viewport) return;

  viewport.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-ausmed-open-panel]');
    if (openBtn) {
      event.preventDefault();
      const id = openBtn.getAttribute('data-ausmed-open-panel');
      if (id) showPanel(viewport, id);
      return;
    }
    if (event.target.closest('[data-ausmed-drawer-back]')) {
      event.preventDefault();
      const previousOpener = viewport.querySelector('[data-ausmed-open-panel][aria-expanded="true"]');
      const openerId = previousOpener?.getAttribute('data-ausmed-open-panel');
      showLevel1(viewport);
      if (openerId) {
        viewport.querySelector(`[data-ausmed-open-panel="${openerId}"]`)?.focus?.();
      }
    }
  });

  const details = getDetails(drawer);
  details?.addEventListener('toggle', () => {
    if (!details.open) {
      showLevel1(viewport);
    }
  });
}

function boot() {
  const drawer = document.querySelector('#ausmed-mobile-menu-drawer');
  if (drawer) initAusmedMobileDrawer(drawer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
